export default "__VITE_ASSET__BcHZXBro__"